import React from 'react';
import {FormattedMessage} from 'react-intl';
import styled from 'styled-components';
import {useAuth} from 'react-oidc-context';

const Container = styled.div`
    font-size: 1.5rem;
    color: var(--text-color);
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
    gap: 16px;
`;

const Text = styled.p`
    display: block;
    font-size: 1rem;
`;

const Button = styled.button<{ variant: 'primary' | 'secondary' }>`
    font-weight: 500;
    color: var(--white);
    border-radius: 2rem;
    text-decoration: none;
    border: solid 1px ${({variant}) => variant === 'primary' ? 'var(--text-color)' : 'var(--primary)'};
    background-color: ${({variant}) => variant === 'primary' ? 'var(--text-color)' : 'var(--primary)'};
    padding: 0.5em 1.2em 0.4em;
    transition: all 0.25s;
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
    font-size: 1em;

    &:hover,
    &:focus {
        background-color: var(--secondary-2);
        color: var(--text-color);
        border-color: var(--text-color);
    }
`;

export function Login() {
    const auth = useAuth();

    return (
        <Container>
            <Text>
                <FormattedMessage id="CONNECT_TEXT_1"/> <br/>
                <FormattedMessage id="CONNECT_TEXT_2"/> <br/>
                <br/>
                <Button onClick={() => auth.signinPopup({popupWindowFeatures: {width: 400, height: 350}})}
                        variant={'primary'}>
                    <FormattedMessage id="BUTTON_LOGIN"/>
                </Button>
            </Text>
            <Text>
                <FormattedMessage id="SIGN_IN_TEXT_1"/> <br/>
                <FormattedMessage id="SIGN_IN_TEXT_2"/> <br/>
                <br/>
                <Button onClick={() => document.location = window.__RUNTIME_CONFIG__.REACT_APP_URL_JAMESPOT_SIGN_IN}
                        variant={'secondary'}>
                    <FormattedMessage id="BUTTON_SIGN_IN"/>
                </Button>
            </Text>
        </Container>
    );
}
